import {
  isValidUrl,
  getUtmKeySegment,
  addInvalidClass,
  removeInvalidClass,
  getFormFieldIndex
} from './validation-helpers';

const areAdditionalUtmDuplicates = (
  formArray: any,
  operationType: string,
  keyName: string,
  getOperationObject: any
) => {
  let isDuplicate = false;

  if (keyName.includes('key')) {
    // compare add_utm with utm_param
    if (
      formArray.conditions.length !== -1 &&
      getOperationObject.operation !== 'Replace' &&
      getOperationObject.operation !== 'Delete'
    ) {
      formArray.conditions.map((conditionData: any) => {
        if (
          conditionData.trigger &&
          ((getOperationObject.operation === 'Add' && conditionData.trigger === 'UTM Parameter') ||
            (getOperationObject.operation === 'Create' && conditionData.trigger === 'Cookie'))
        ) {
          if (conditionData.value.split('=')[0] === getOperationObject[keyName]) {
            isDuplicate = true;
          }
        }
        return null;
      });
    }

    if (formArray[operationType].length > 0 && operationType === 'additional_utm') {
      for (let k = 0; k < formArray[operationType].length; k++) {
        const element = formArray[operationType][k];
        for (let i = 0; i < element.additional_utm_operation.length; i++) {
          for (let j = 0; j < element.additional_utm_operation.length; j++) {
            const keyOne = element.additional_utm_operation[i].operation.includes('Replace')
              ? keyName
              : 'utm_key';
            const keyTwo = element.additional_utm_operation[j].operation.includes('Replace')
              ? keyName
              : 'utm_key';
            if (i !== j) {
              if (
                element.additional_utm_operation[i][keyOne] ===
                element.additional_utm_operation[j][keyTwo]
              ) {
                return true;
              }
            }
          }
        }
      }
    }

    if (formArray[operationType].length > 0 && operationType !== 'additional_utm') {
      const defaultKey = operationType === 'cookie_operation' ? 'cookie_key' : 'utm_key';
      for (let i = 0; i < formArray[operationType].length; i++) {
        for (let j = 0; j < formArray[operationType].length; j++) {
          const keyOne = formArray[operationType][i].operation.includes('Replace')
            ? keyName
            : defaultKey;
          const keyTwo = formArray[operationType][j].operation.includes('Replace')
            ? keyName
            : defaultKey;
          if (i !== j) {
            if (formArray[operationType][i][keyOne] === formArray[operationType][j][keyTwo]) {
              return true;
            }
          }
        }
      }
    }

    if (
      formArray.timeframe &&
      formArray.timeframe.timeframe_utm_test_id_enabled &&
      operationType !== 'cookie_operation'
    ) {
      if (formArray.timeframe.utm_test_id.split('=')[0] === getOperationObject[keyName]) {
        return true;
      }
    }
  }
  return isDuplicate;
};

// Handles validation for every field inside an array-typed form field (variant_splits, conditions,
// additional_utm, cookie_operation, dow_operation). Returns true when the caller's topLevelLoop
// over validationArray should stop immediately (a duplicate-key conflict was found) — mirrors the
// two `break topLevelLoop` sites from before this was extracted into its own function, since a
// labeled break can't reach across a function boundary.
export const validateArrayField = (
  formObj: any,
  validationArray: string | any[],
  i: number,
  bulkPlover: any,
  formFieldMappingObj: Record<string, string>,
  splitTotalArray: any[],
  invalidationArray: any[]
): boolean => {
  let keyArr: any;
  let message: string;

  for (let j = 0; j < formObj[validationArray[i]].length; j++) {
    keyArr = Object.keys(formObj[validationArray[i]][j]);
    for (let k = 0; k < keyArr.length; k++) {
      switch (keyArr[k]) {
        case 'variant_url':
          if (
            formObj[validationArray[i]][j][keyArr[k]] !== '' &&
            isValidUrl(formObj[validationArray[i]][j][keyArr[k]])
          ) {
            const index = getFormFieldIndex(invalidationArray, `${keyArr[k]} ${j + 1}`);
            if (index !== -1) {
              invalidationArray.splice(index, 1);
            }
          } else {
            // checking for bulk plover feature
            const isBlank = formObj[validationArray[i]][j][keyArr[k]] === '';
            if (bulkPlover.isBulkPlover) {
              message = isBlank
                ? `Sheet Row ${bulkPlover.currentRow} - ${
                    formFieldMappingObj[keyArr[k]]
                  } ${j + 1} cannot be left blank`
                : `Sheet Row ${bulkPlover.currentRow} - ${formFieldMappingObj[keyArr[k]]} ${
                    j + 1
                  } is an invalid URL. Valid URL must start with HTTPS and contain full URL without UTM Parameters.`;
            } else {
              message = isBlank
                ? `${formFieldMappingObj[keyArr[k]]} ${j + 1} cannot be left blank`
                : `${formFieldMappingObj[keyArr[k]]} ${
                    j + 1
                  } is an invalid URL. Valid URL must start with HTTPS and contain full URL without UTM Parameters.`;
            }
            invalidationArray.push(message);
          }
          break;
        case 'split':
          splitTotalArray.push(formObj[validationArray[i]][j][keyArr[k]]);
          if (j === formObj[validationArray[i]].length - 1) {
            const splitTotal = splitTotalArray.reduce((a, b) => a + b, 0);
            message = 'Split percentage total should be 100';
            if (splitTotal === 100) {
              const index = getFormFieldIndex(invalidationArray, message);
              if (index !== -1) {
                invalidationArray.splice(index, 1);
              }

              removeInvalidClass(keyArr[k], 'id');
            } else {
              invalidationArray.push(message);

              if (!document.getElementById(keyArr[k])?.classList.contains('invalid')) {
                addInvalidClass(keyArr[k], 'id');
              }
            }
          }

          break;
        case 'variants': {
          const splitDOWTotalArray: any = [];
          for (let v = 0; v < formObj[validationArray[i]][j][keyArr[k]].length; v++) {
            const element = formObj[validationArray[i]][j][keyArr[k]][v];
            if (element.name === '' && element.url === '') {
              message = `Day of the week ${j + 1} variant ${v + 1} cannot be left blank`;
              invalidationArray.push(message);

              if (
                !document
                  .getElementById(`dow_variant_id-${j + 1}-${v + 1}`)
                  ?.classList.contains('invalid')
              ) {
                addInvalidClass(`dow_variant_id-${j + 1}-${v + 1}`, 'id');
              }
            } else {
              splitDOWTotalArray.push(element.split);
              if (v === formObj[validationArray[i]][j][keyArr[k]].length - 1) {
                const splitTotal = splitDOWTotalArray.reduce((a: any, b: any) => a + b, 0);
                message = `Day of the week ${j + 1}, All splits must total to 100%`;

                if (splitTotal === 100) {
                  const index = getFormFieldIndex(invalidationArray, message);
                  if (index !== -1) {
                    invalidationArray.splice(index, 1);
                  }

                  removeInvalidClass(`split-${j + 1}`, 'id');
                } else {
                  invalidationArray.push(message);

                  if (!document.getElementById(`split-${j + 1}`)?.classList.contains('invalid')) {
                    addInvalidClass(`split-${j + 1}`, 'id');
                  }
                }
              }
            }
          }
          break;
        }
        case 'start_time':
        case 'end_time':
          for (let dowIndex = 0; dowIndex < formObj[validationArray[i]].length; dowIndex++) {
            const element = formObj[validationArray[i]][dowIndex];
            if (keyArr[k] === 'start_time' && element.start_time) {
              if (element.end_time === '' || element.end_time === undefined) {
                message = `Day of the week ${dowIndex + 1} end time is mising`;
                invalidationArray.push(message);
              }
            } else if (keyArr[k] === 'end_time' && element.end_time) {
              if (element.start_time === '' || element.start_time === undefined) {
                message = `Day of the week ${dowIndex + 1} start time is mising`;
                invalidationArray.push(message);
              }
            }
          }
          break;
        case 'day':
          if (formObj[validationArray[i]][j].day.length > 0) {
            if (formObj[validationArray[i]][j].variants.length === 0) {
              message = `Day of the week ${j + 1} please select variants for allocation`;
              invalidationArray.push(message);
            }
          } else if (
            (formObj[validationArray[i]][j].day.length === 0 &&
              formObj[validationArray[i]][j].variants.length > 0) ||
            (formObj[validationArray[i]][j].day.length === 0 &&
              (formObj[validationArray[i]][j].end_time.length > 0 ||
                formObj[validationArray[i]][j].start_time.length > 0))
          ) {
            message = `Day of the week ${j + 1} , please select day`;
            invalidationArray.push(message);
          }
          break;
        default:
          switch (true) {
            // Checking validation for Rule Name , variant_splits , varinat ID
            case formObj[validationArray[i]][j][keyArr[k]] === '' &&
              keyArr[k] !== 'operator' &&
              validationArray[i] !== 'dow_operation' &&
              validationArray[i] !== 'additional_utm' &&
              validationArray[i] !== 'cookie_operation' &&
              validationArray[i] !== 'conditions':
              message = `${formFieldMappingObj[keyArr[k]]} ${j + 1} cannot be left blank`;

              if (validationArray[i] === 'variant_splits') {
                message = `${
                  formFieldMappingObj[
                    validationArray[i].substring(0, validationArray[i].length - 1)
                  ]
                } ${j + 1} - ${formFieldMappingObj[keyArr[k]]} cannot be left blank`;
              }
              invalidationArray.push(message);

              if (
                !document.getElementById(`${keyArr[k]}-${j + 1}`)?.classList.contains('invalid')
              ) {
                addInvalidClass(`${keyArr[k]}-${j + 1}`, 'id');
              }

              break;
            // Added case for validation for trigger in conditions
            case formObj[validationArray[i]][j][keyArr[k]] === '' &&
              keyArr[k] !== 'operator' &&
              validationArray[i] !== 'additional_utm' &&
              validationArray[i] !== 'cookie_operation' &&
              validationArray[i] !== 'variant_splits':
              // checking if only trigger is left blank
              if (keyArr[k] === 'trigger' && validationArray[i] === 'conditions') {
                message = `${
                  formFieldMappingObj[
                    validationArray[i].substring(0, validationArray[i].length - 1)
                  ]
                } ${j + 1} - ${formFieldMappingObj[keyArr[k]]} cannot be left blank`;
                invalidationArray.push(message);
                if (
                  !document.getElementById(`${keyArr[k]}-${j + 1}`)?.classList.contains('invalid')
                ) {
                  addInvalidClass(`${keyArr[k]}-${j + 1}`, 'id');
                }
                break;
              } else if (formObj[validationArray[i]][j].trigger && keyArr[k] !== 'trigger') {
                // checking key validation for cookies in condition
                if (
                  validationArray[i] === 'conditions' &&
                  keyArr[k] === 'value' &&
                  formObj[validationArray[i]][j][keyArr[k]].split('=')[0] === '' &&
                  formObj[validationArray[i]][j].trigger === 'Cookie'
                ) {
                  message = `${
                    formFieldMappingObj[
                      validationArray[i].substring(0, validationArray[i].length - 1)
                    ]
                  } ${j + 1} - Key cannot be left blank`;
                  invalidationArray.push(message);

                  if (!document.getElementById(`key-${j + 1}`)?.classList.contains('invalid')) {
                    addInvalidClass(`key-${j + 1}`, 'id');
                  }
                }
                // checking validation for remaining fields in condition
                message = `${formFieldMappingObj[keyArr[k]]} ${j + 1} cannot be left blank`;
                if (validationArray[i] === 'conditions') {
                  message = `${
                    formFieldMappingObj[
                      validationArray[i].substring(0, validationArray[i].length - 1)
                    ]
                  } ${j + 1} - ${formFieldMappingObj[keyArr[k]]} cannot be left blank`;
                }
                invalidationArray.push(message);
                if (
                  !document.getElementById(`${keyArr[k]}-${j + 1}`)?.classList.contains('invalid')
                ) {
                  addInvalidClass(`${keyArr[k]}-${j + 1}`, 'id');
                }
              }
              break;
            case validationArray[i] === 'conditions' &&
              keyArr[k] === 'value' &&
              formObj[validationArray[i]][j][keyArr[k]].split('=')[0] === '':
            case validationArray[i] === 'conditions' &&
              keyArr[k] === 'value' &&
              formObj[validationArray[i]][j][keyArr[k]].split('=')[1] === '':
              // UTM Parameter Key
              if (
                validationArray[i] === 'conditions' &&
                keyArr[k] === 'value' &&
                formObj[validationArray[i]][j][keyArr[k]].split('=')[0] === ''
              ) {
                message = `${
                  formFieldMappingObj[
                    validationArray[i].substring(0, validationArray[i].length - 1)
                  ]
                } ${j + 1} - Key cannot be left blank`;
                invalidationArray.push(message);

                if (!document.getElementById(`key-${j + 1}`)?.classList.contains('invalid')) {
                  addInvalidClass(`key-${j + 1}`, 'id');
                }
              }

              // UTM Parameter Value
              if (
                validationArray[i] === 'conditions' &&
                keyArr[k] === 'value' &&
                formObj[validationArray[i]][j][keyArr[k]].split('=')[1] === ''
              ) {
                message = `${
                  formFieldMappingObj[
                    validationArray[i].substring(0, validationArray[i].length - 1)
                  ]
                } ${j + 1} - Value cannot be left blank`;
                invalidationArray.push(message);

                if (
                  !document.getElementById(`${keyArr[k]}-${j + 1}`)?.classList.contains('invalid')
                ) {
                  addInvalidClass(`${keyArr[k]}-${j + 1}`, 'id');
                }
              }
              break;
            case validationArray[i] === 'additional_utm':
              if (formObj[validationArray[i]][j][keyArr[k]].length > 0) {
                for (let g = 0; g < formObj[validationArray[i]][j][keyArr[k]].length; g++) {
                  const element = formObj[validationArray[i]][j][keyArr[k]][g];
                  if (keyArr[k] === 'additional_utm_operation') {
                    const keyArrUtm = Object.keys(element);
                    for (let h = 0; h < keyArrUtm.length; h++) {
                      if (
                        (element.operation === 'Add' || element.operation === 'Override') &&
                        keyArrUtm[h] !== 'operation' &&
                        element[keyArrUtm[h]] === ''
                      ) {
                        message = `${formFieldMappingObj[validationArray[i]]} ${
                          j + 1
                        } - Row ${g + 1} - ${
                          element.operation.length > 0 ? element.operation : ''
                        } - ${
                          keyArrUtm[h].indexOf('_') !== -1
                            ? keyArrUtm[h].split('_')[1]
                            : keyArrUtm[h]
                        } cannot be left blank`;
                        invalidationArray.push(message);
                        if (
                          !document
                            .getElementById(`${keyArrUtm[h]}-${j + 1}-${g + 1}`)
                            ?.classList.contains('invalid')
                        ) {
                          addInvalidClass(`${keyArrUtm[h]}-${j + 1}-${g + 1}`, 'id');
                        }
                      } else if (
                        element.operation.length === 0 &&
                        keyArrUtm[h] === 'operation' &&
                        element[keyArrUtm[h]] === ''
                      ) {
                        message = `${formFieldMappingObj[validationArray[i]]} ${
                          j + 1
                        } - Row ${g + 1} - ${keyArrUtm[h]} cannot be left blank`;
                        invalidationArray.push(message);

                        if (
                          !document
                            .getElementById(`add_utm_${keyArrUtm[h]}-${j + 1}-${g + 1}`)
                            ?.classList.contains('invalid')
                        ) {
                          addInvalidClass(`add_utm_${keyArrUtm[h]}-${j + 1}-${g + 1}`, 'id');
                        }
                      } else if (
                        element.operation.length !== 0 &&
                        keyArrUtm[h] !== 'operation' &&
                        element[keyArrUtm[h]] === '' &&
                        (keyArrUtm[h] === 'utm_key' || keyArrUtm[h] === 'replace_key')
                      ) {
                        if (element.operation === 'Replace') {
                          message = `${formFieldMappingObj[validationArray[i]]} ${
                            j + 1
                          } - Row ${g + 1} - ${
                            element.operation.length > 0 ? element.operation : ''
                          } ${getUtmKeySegment(keyArrUtm[h])} ${
                            keyArrUtm[h] === 'replace_key' || keyArrUtm[h] === 'cki_replace_key'
                              ? '2'
                              : '1'
                          } cannot be left blank`;
                          invalidationArray.push(message);
                        } else {
                          message = `${formFieldMappingObj[validationArray[i]]} ${
                            j + 1
                          } - Row ${g + 1} - ${
                            element.operation.length > 0 ? element.operation : ''
                          }-${g + 1} ${
                            keyArrUtm[h].indexOf('_') !== -1
                              ? keyArrUtm[h].split('_')[1]
                              : keyArrUtm[h]
                          } cannot be left blank`;
                          invalidationArray.push(message);
                        }

                        if (
                          !document
                            .getElementById(`${keyArrUtm[h]}-${j + 1}-${g + 1}`)
                            ?.classList.contains('invalid')
                        ) {
                          addInvalidClass(`${keyArrUtm[h]}-${j + 1}-${g + 1}`, 'id');
                        }
                      } else if (
                        areAdditionalUtmDuplicates(
                          formObj,
                          validationArray[i],
                          keyArrUtm[h],
                          formObj[validationArray[i]][j]
                        )
                      ) {
                        message = `1 or more duplicate or conflicting ${
                          formFieldMappingObj[validationArray[i]]
                        } keys have been detected`;
                        invalidationArray.push(message);
                        return true;
                      }
                    }
                  }
                }
              } else if (keyArr[k] === 'additional_utm_url') {
                if (
                  formObj[validationArray[i]][j].additional_utm_operation?.length > 0 &&
                  formObj[validationArray[i]][j].additional_utm_url?.length === 0
                ) {
                  message = `Please Select Variant for ${
                    formFieldMappingObj[validationArray[i]]
                  } ${j + 1}`;
                  if (
                    !document
                      .getElementById(`utm_variant_id-${j + 1}`)
                      ?.classList.contains('invalid')
                  ) {
                    document.getElementById(`utm_variant_id-${j + 1}`)?.classList.add('invalid');
                  }
                  invalidationArray.push(message);
                }
              }
              break;
            // handle additional_UTM and cookie_operation CREATE/ADD operation
            case validationArray[i] === 'cookie_operation' &&
              (formObj[validationArray[i]][j].operation === 'Add' ||
                formObj[validationArray[i]][j].operation === 'Create') &&
              formObj[validationArray[i]][j][keyArr[k]].length < 1:
              message = `${formFieldMappingObj[validationArray[i]]} ${j + 1} - ${
                formObj[validationArray[i]][j].operation.length > 0
                  ? formObj[validationArray[i]][j].operation
                  : ''
              } ${
                keyArr[k].indexOf('_') !== -1 ? keyArr[k].split('_')[1] : keyArr[k]
              } cannot be left blank`;
              invalidationArray.push(message);
              if (
                !document.getElementById(`${keyArr[k]}-${j + 1}`)?.classList.contains('invalid')
              ) {
                addInvalidClass(`${keyArr[k]}-${j + 1}`, 'id');
              }
              break;

            // Checking validation if only operation field is empty in additional UTM
            case validationArray[i] === 'cookie_operation' &&
              formObj[validationArray[i]][j][keyArr[k]].length < 1 &&
              !keyArr[k].includes('value'):
              if (
                formObj[validationArray[i]][j].operation === '' &&
                keyArr[k] !== 'utm_key' &&
                keyArr[k] !== 'replace_key' &&
                keyArr[k] !== 'cookie_key' &&
                keyArr[k] !== 'cki_replace_key'
              ) {
                message = `${formFieldMappingObj[validationArray[i]]} ${j + 1} - ${
                  formObj[validationArray[i]][j].operation.length > 0
                    ? formObj[validationArray[i]][j].operation
                    : ''
                } ${
                  keyArr[k].indexOf('_') !== -1 ? keyArr[k].split('_')[1] : keyArr[k]
                } cannot be left blank`;
                invalidationArray.push(message);
                const TriggerElementID =
                  validationArray[i] === 'additional_utm'
                    ? `add_utm_${keyArr[k]}-${j + 1}`
                    : `cookie_${keyArr[k]}-${j + 1}`;
                if (!document.getElementById(TriggerElementID)?.classList.contains('invalid')) {
                  addInvalidClass(TriggerElementID, 'id');
                }
              } else if (formObj[validationArray[i]][j].operation !== '') {
                if (formObj[validationArray[i]][j].operation === 'Replace') {
                  message = `${formFieldMappingObj[validationArray[i]]} ${j + 1} - ${
                    formObj[validationArray[i]][j].operation.length > 0
                      ? formObj[validationArray[i]][j].operation
                      : ''
                  } ${getUtmKeySegment(keyArr[k])} ${
                    keyArr[k] === 'replace_key' || keyArr[k] === 'cki_replace_key' ? '2' : '1'
                  } cannot be left blank`;
                  invalidationArray.push(message);
                } else {
                  message = `${formFieldMappingObj[validationArray[i]]} ${j + 1} - ${
                    formObj[validationArray[i]][j].operation.length > 0
                      ? formObj[validationArray[i]][j].operation
                      : ''
                  } ${
                    keyArr[k].indexOf('_') !== -1 ? keyArr[k].split('_')[1] : keyArr[k]
                  } cannot be left blank`;
                  invalidationArray.push(message);
                }

                if (
                  !document.getElementById(`${keyArr[k]}-${j + 1}`)?.classList.contains('invalid')
                ) {
                  addInvalidClass(`${keyArr[k]}-${j + 1}`, 'id');
                }
              }
              break;
            // handle additional_UTM and cookie_operation duplicate keys
            case (validationArray[i] === 'additional_utm' ||
              validationArray[i] === 'cookie_operation') &&
              keyArr[k].includes('key') &&
              keyArr[k].length > 0:
              if (
                areAdditionalUtmDuplicates(
                  formObj,
                  validationArray[i],
                  keyArr[k],
                  formObj[validationArray[i]][j]
                )
              ) {
                message = `1 or more duplicate or conflicting ${
                  formFieldMappingObj[validationArray[i]]
                } keys have been detected`;
                invalidationArray.push(message);
                return true;
              }
              break;
            default:
              if (getFormFieldIndex(invalidationArray, `${keyArr[k]} ${j + 1}`) !== -1) {
                invalidationArray.splice(
                  getFormFieldIndex(invalidationArray, `${keyArr[k]} ${j + 1}`),
                  1
                );
              }
              removeInvalidClass(`${keyArr[k]}-${j + 1}`, 'id');

              // below handles removing the invalid class from the key input field for the utm parameter updates trigger when it is valid.
              if (
                formObj.conditions &&
                formObj.additional_utm[j] &&
                formObj.additional_utm[j].utm_key !== ''
              ) {
                removeInvalidClass(`utm_key-${j + 1}`, 'id');
              }

              // below handles removing the invalid class from the value input field for the utm parameter updates trigger when it is valid.
              if (
                formObj.conditions &&
                formObj.additional_utm[j] &&
                formObj.additional_utm[j].utm_value !== ''
              ) {
                removeInvalidClass(`utm_value-${j + 1}`, 'id');
              }

              // below handles removing the invalid class from the replace value input field for the utm parameter updates trigger when it is valid.
              if (
                formObj.conditions &&
                formObj.additional_utm[j] &&
                formObj.additional_utm[j].replace_key !== ''
              ) {
                removeInvalidClass(`replace_key-${j + 1}`, 'id');
              }
          }
      }
    }
  }

  return false;
};
